var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRegistrySyncedCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.454 6.474a.6.6 0 0 0-.913-.779l-3.43 4.02-1.7-1.595a.6.6 0 0 0-.82.876L6.75 11.02a.6.6 0 0 0 .866-.049z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.001.667A7.34 7.34 0 0 0 .668 8a7.34 7.34 0 0 0 7.333 7.333A7.34 7.34 0 0 0 15.335 8 7.34 7.34 0 0 0 8 .667M1.868 8a6.14 6.14 0 0 1 6.133-6.133A6.14 6.14 0 0 1 14.135 8 6.14 6.14 0 0 1 8 14.133 6.14 6.14 0 0 1 1.868 8",
  clipRule: "evenodd"
})));
export { SvgRegistrySyncedCheck as ReactComponent };